// Checkout della tienda Impultienda italiana (kitanimatore). La URL raíz muestra el checkout.
export const checkoutUrl = 'https://kitanimatore.impultienda.ar'

export { gallery, heroImage } from './media'
export type { GalleryItem } from './media'

export const siteMeta = {
  lang: 'it',
  title: "Il Kit dell'Animatore: oltre 300 materiali pronti per il tuo gruppo giovani",
}

export const brand = {
  eyebrow: 'Per animatori ed educatori dei gruppi giovani',
  headline: 'Il tuo prossimo incontro non deve partire da zero.',
  headlineAccent: 'Oltre 300 materiali pronti per incontri, ritiri e campi.',
  name: "Il Kit dell'Animatore",
  subheadline: '5 volumi + 5 bonus',
  description:
    'Idee per gli incontri, giochi con messaggio, tracce già scritte, sfide e preghiere, spiegati passo dopo passo, perché i ragazzi abbiano voglia di tornare.',
  tagline: 'Scegli. Stampa. Guida.',
}

export const heroCta = 'Voglio il kit completo'

export const heroNote = 'Accesso immediato · PDF da stampare · Pagamento unico'

export const heroGuarantee = 'Garanzia di 7 giorni soddisfatti o rimborsati.'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '44', label: 'Idee per incontri e ritiri' },
  { value: '33', label: 'Giochi con messaggio' },
  { value: '25', label: 'Incontri già pronti' },
  { value: '100', label: 'Versetti con riflessione' },
]

export interface Situation {
  title: string
  text: string
}

export const situationsTitle = 'Ti ci ritrovi?'

export const situationsIntro =
  'Se guidi un gruppo giovani, almeno una di queste situazioni la conosci bene.'

export const situations: Situation[] = [
  {
    title: "L'incontro è tra due giorni e non sai ancora da dove cominciare.",
    text: "Di nuovo su internet fino a tardi, a cercare un'idea che funzioni davvero.",
  },
  {
    title: 'I ragazzi stanno col telefono in mano e non si smuovono.',
    text: "Il discorso non decolla e senti che l'incontro ti sta sfuggendo di mano.",
  },
  {
    title: 'Dopo la Cresima, il gruppo si svuota.',
    text: 'Sempre gli stessi giochi e gli stessi temi, e ogni anno ne restano di meno.',
  },
  {
    title: 'Un ritiro o un campo, e tocca tutto a te.',
    text: 'Programma, preghiere, giochi e orari: li prepari da zero, dopo il lavoro o lo studio.',
  },
]

export const situationsClosing =
  'Non ti manca il cuore per i ragazzi. Ti mancano il tempo e dei materiali pronti da prendere in 5 minuti.'

export const comparisonCopy = {
  title: "Dalla ricerca all'ultimo minuto a incontri che i ragazzi aspettano.",
  oldEyebrow: 'Prima',
  oldLabel: "Senza il Kit dell'Animatore",
  atlasEyebrow: 'Dopo',
  atlasLabel: "Con il Kit dell'Animatore",
  closing: 'Meno tempo a preparare. Più tempo per i ragazzi.',
}

export const comparisonOld: string[] = [
  'Cerchi idee su internet il giovedì sera.',
  'Sempre gli stessi giochi e gli stessi temi.',
  'Il discorso non decolla e i ragazzi si rifugiano nel telefono.',
  'Ritiri e campi da organizzare da zero, da solo.',
]

export const comparisonAtlas: string[] = [
  '44 idee per gli incontri, spiegate passo dopo passo.',
  '33 giochi che rompono il ghiaccio e portano al confronto.',
  '25 incontri sulla vita vera dei ragazzi, con le domande già pronte.',
  'Programmi pronti per giornate di spiritualità, ritiri e campi.',
]

export interface DemoStep {
  number: string
  title: string
  text: string
}

export const demoCopy = {
  title: "L'incontro è venerdì. Tu hai il programma pronto in 5 minuti.",
  questionLabel: 'Il tuo gruppo ha bisogno di:',
  question: 'Un incontro che rompa il ghiaccio e apra un discorso sulla fede.',
}

export const demoSteps: DemoStep[] = [
  {
    number: '01',
    title: 'Scegli',
    text: "Apri il Volume 2 e scegli il gioco iniziale, poi dal Volume 3 l'incontro.",
  },
  {
    number: '02',
    title: 'Prepara',
    text: 'Stampa la scheda e prepara i materiali semplici in 10 minuti.',
  },
  {
    number: '03',
    title: 'Guida',
    text: 'Gioco, Parola di Dio, condivisione, preghiera e sfida della settimana: è già tutto scritto.',
  },
]

export const galleryCopy = {
  title: 'Guarda dentro.',
  subtitle:
    "Pagine vere del Kit dell'Animatore: ogni idea è spiegata passo dopo passo, con tempo, materiali, Parola, domande e preghiera.",
  footer: 'Oltre 300 materiali pronti. Un solo kit, da usare subito.',
  cta: 'Voglio il kit completo',
}

export const systemCopy = {
  title: "5 volumi. Tutto quello che serve per l'anno pastorale.",
  subtitle: "Il kit completo per chi guida un gruppo, diviso in cinque volumi pratici, con la mappa dell'anno da settembre a giugno.",
  areaLabel: 'Volume',
  includesTitle: 'In ogni idea e in ogni incontro trovi:',
  closing:
    "Non è l'ennesimo libro sulla pastorale giovanile. Sono strumenti pronti: li prendi e guidi l'incontro.",
}

export interface Module {
  number: string
  title: string
  detail: string
  summary: string
  description: string
  spine: string
}

export const modules: Module[] = [
  {
    number: '1',
    title: 'Idee per incontri e ritiri',
    detail: '44 idee pronte',
    summary: 'Confronto, preghiera, fare gruppo, servizio, giornate di spiritualità e uscite.',
    description: 'Ogni idea è spiegata passo dopo passo, con tempo, numero di ragazzi e materiali.',
    spine: 'bg-blue-400',
  },
  {
    number: '2',
    title: 'Giochi e dinamiche con messaggio',
    detail: '33 giochi',
    summary: 'Per cominciare, fiducia, collaborazione, movimento e riflessione.',
    description: 'Ogni gioco ha il suo messaggio, un brano della Bibbia e una domanda finale.',
    spine: 'bg-blue-500',
  },
  {
    number: '3',
    title: 'Incontri pronti sulla vita dei ragazzi',
    detail: '25 incontri',
    summary: 'Identità, amicizia, telefono, perdono, vocazione, dubbi di fede e molto altro.',
    description: "L'incontro intero già scritto: come iniziare, Parola, 5 domande, attività e preghiera.",
    spine: 'bg-blue-600',
  },
  {
    number: '4',
    title: 'La fede di ogni giorno',
    detail: '28 sfide + 100 versetti',
    summary: 'Sfide settimanali e versetti con riflessione e preghiera.',
    description: 'Perché la fede dei ragazzi resti viva anche tra un incontro e l\'altro.',
    spine: 'bg-blue-800',
  },
  {
    number: '5',
    title: "Il laboratorio dell'animatore",
    detail: '20 strategie + guide',
    summary: 'Come far tornare i ragazzi, guidare la condivisione e preparare ritiri e campi.',
    description: "Traccia dell'incontro da stampare, programmi pronti e la mappa dell'anno pastorale.",
    spine: 'bg-blue-900',
  },
]

export const mapIncludes: string[] = [
  "Obiettivo e durata dell'incontro",
  'I materiali che servono',
  'Lo svolgimento passo dopo passo',
  'La Parola di Dio con il riferimento',
  'Le domande per la condivisione',
  'La preghiera e la sfida della settimana',
]

export interface Bonus {
  tag: string
  title: string
  benefit: string
}

export const bonusesCopy = {
  title: 'In più ricevi 5 bonus.',
  subtitle: 'Materiali pronti che ti semplificano la vita con il gruppo per tutto l\'anno.',
  badge: 'Incluso',
  closing: 'Tutti e 5 i bonus sono nel tuo kit.',
}

export const bonuses: Bonus[] = [
  { tag: 'Bonus 01', title: 'Sfida dei 21 giorni "Riaccendi la fede"', benefit: '21 giorni con la Parola, una riflessione e una piccola sfida.' },
  { tag: 'Bonus 02', title: 'Percorso Dopocresima', benefit: '8 incontri pronti per non perderli dopo la Cresima.' },
  { tag: 'Bonus 03', title: 'Locandine, inviti e ricordini', benefit: '24 locandine e inviti, segnalibri e bigliettini da stampare.' },
  { tag: 'Bonus 04', title: 'I 4 Vangeli in gioco', benefit: 'Quiz e schede per il gruppo.' },
  { tag: 'Bonus 05', title: "12 lettere all'animatore", benefit: 'Sostegno e formazione per ogni mese.' },
]

export interface Testimonial {
  initials: string
  quote: string
  author: string
  role: string
  city?: string
}

// Vacío a propósito: solo se cargan testimonios reales de compradores italianos.
export const testimonials: Testimonial[] = []

export const guaranteeCopy = {
  title: 'Garanzia di 7 giorni. Acquisti senza rischi.',
  paragraphs: [
    'Sfoglia tutti i volumi e i bonus, provali in un incontro con il tuo gruppo.',
    "Se entro 7 giorni dall'acquisto ritieni che il Kit dell'Animatore non faccia per te, puoi chiedere il rimborso secondo le condizioni della garanzia.",
  ],
  closing: 'Un solo pagamento. Nessun abbonamento. Accesso per sempre.',
}

export interface FaqItem {
  question: string
  answer: string
}

export const faqTitle = 'Domande frequenti'

export interface Offer {
  title: string
  name: string
  summary: string
  includes: string[]
  price: string
  currency: string
  /** ISO code sent to the Meta pixel. */
  currencyCode: string
  cta: string
  note: string
}

export const offer: Offer = {
  title: "Tutto il Kit dell'Animatore. In un solo acquisto.",
  name: "Il Kit dell'Animatore",
  summary: '5 volumi + 5 bonus',
  includes: [
    '44 idee per incontri e ritiri',
    '33 giochi e dinamiche con messaggio',
    '25 incontri pronti sulla vita dei ragazzi',
    '28 sfide settimanali + 100 versetti',
    "Il laboratorio dell'animatore: 20 strategie e guide",
    'Tutti e 5 i bonus inclusi',
    'PDF da stampare e da aprire sul telefono',
    'Accesso immediato e per sempre',
  ],
  price: '19',
  currency: '€',
  currencyCode: 'EUR',
  cta: 'Sì, voglio il kit completo',
  note: 'Pagamento unico · Nessun abbonamento · Garanzia di 7 giorni',
}

export const faqs: FaqItem[] = [
  {
    question: 'Ho appena cominciato a fare l\'animatore. Fa per me?',
    answer:
      'Sì. Ogni idea e ogni incontro sono spiegati passo dopo passo: cosa fare, quanto dura ogni parte e quali materiali preparare. Nel Volume 5 trovi anche le strategie per chi guida un gruppo.',
  },
  {
    question: 'Per quale età sono i materiali?',
    answer:
      'Per adolescenti e giovani, più o meno dai 14 ai 25 anni: gruppi giovani, gruppi adolescenti, oratorio, associazioni e movimenti. Per i più piccoli del dopocresima c\'è il percorso del Bonus 2.',
  },
  {
    question: 'E se a volte vengono in pochi?',
    answer:
      'Ogni idea del Volume 1 indica per quanti ragazzi funziona, così scegli quella adatta al gruppo di quella sera. Nel Volume 5 trovi anche le strategie per quando agli incontri vengono in pochi.',
  },
  {
    question: 'Posso usarlo sul telefono?',
    answer:
      'Sì. Apri i PDF su telefono, tablet o computer, anche durante l\'incontro.',
  },
  {
    question: 'Posso stampare i materiali?',
    answer: 'Sì. Ricevi tutto in PDF, già pronto da stampare. I PDF non sono modificabili.',
  },
  {
    question: 'Come ricevo il kit? Devo pagare ogni mese?',
    answer: `Ricevi l'accesso digitale via e-mail subito dopo il pagamento. È un acquisto unico da ${offer.price} ${offer.currency}, senza abbonamento.`,
  },
  {
    question: 'È una pubblicazione ufficiale della Chiesa?',
    answer:
      'No. Sono materiali di supporto indipendenti per animatori ed educatori, fedeli all\'insegnamento della Chiesa cattolica. Adattali al tuo gruppo e alle indicazioni della tua parrocchia.',
  },
  {
    question: 'E se non fa per me?',
    answer: 'Puoi chiedere il rimborso entro 7 giorni, secondo le condizioni della garanzia.',
  },
]

export const finalCtaCopy = {
  title: 'Oltre 300 materiali pronti. Per ogni incontro.',
  subtitle:
    'Basta ripartire da zero. Idee, giochi, incontri, sfide e preghiere, tutti in ordine in un solo kit.',
  summary: '5 volumi + 5 bonus',
  cta: 'Voglio il kit completo',
}

export const trustBadges = {
  access: 'Accesso immediato',
  payment: 'Pagamento unico',
  guarantee: 'Garanzia di 7 giorni',
}

// Not rendered (the sticky bar was removed); kept so the unused StickyCta file still compiles.
export const stickyCtaCopy = {
  label: '5 volumi + 5 bonus',
  cta: 'Voglio il kit',
}

export const galleryUi = {
  carousel: 'carosello',
  galleryLabel: "Pagine di esempio del Kit dell'Animatore",
  imageAlt: (title: string) => `Pagina del Kit dell'Animatore: ${title}`,
  previous: 'Pagina precedente',
  next: 'Pagina successiva',
  goTo: (title: string) => `Vai a: ${title}`,
  hint: (current: number, total: number) =>
    `Scorri o usa le frecce: ${current} di ${total} pagine di esempio`,
}

export const footerCopy = {
  tagline:
    'Prodotto digitale · Accesso immediato · Garanzia di 7 giorni · Materiali di supporto indipendenti per animatori ed educatori. Non sono una pubblicazione ufficiale della Chiesa.',
  rights: 'Tutti i diritti riservati.',
  links: [
    { label: 'Termini e condizioni', href: '#termini' },
    { label: 'Informativa sulla privacy', href: '#privacy' },
    { label: 'Contatti', href: '#contatti' },
  ],
}

export const heroImageAlt =
  "Il Kit dell'Animatore: 5 volumi e 5 bonus, oltre 300 materiali pronti per il gruppo giovani"
